import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import * as io from 'socket.io-client';
import * as feathers from 'feathers-client';

import { ApiService } from '../services/api.service';
import { Visitor } from './visitor';

import { environment } from '../../environments/environment';
import * as auth from 'feathers-authentication-client';
import * as hooks from 'feathers-hooks';
import {Subject} from 'rxjs/Subject';


@Injectable()
export class VisitorsService  {

  public visitors$: Observable<Visitor[]>;
  private visitsObserver: Observer<Visitor[]>;
  private feathersService: any;
  private feathersServicewinners: any;
  private dataStore: {
    visitors: Visitor[],
  };
  public newWinnerSubject = new Subject<any>();

  constructor(private apiService: ApiService) {

    const socket = io(this.apiService.getApiUrl());
    const feathersApp = feathers();
    feathersApp.configure(feathers.socketio(socket));
    feathersApp.configure(hooks())
    feathersApp.configure(auth())
    feathersApp.authenticate({
        strategy: 'jwt',
        accessToken: localStorage.getItem('token')
    })

    this.feathersService = feathersApp.service('visits');
    this.feathersServicewinners = feathersApp.service('winners');


    this.feathersService.on('created', (visitor) => this.onCreated(visitor));

    this.feathersService.on('removed', (visitor) => this.onRemoved(visitor));    

    this.feathersServicewinners.on('created', (winner)=> this.onWinner(winner));

    this.visitors$ = new Observable(observer => this.visitsObserver = observer);

    this.dataStore = { visitors: [] };
    }
  private onRemoved(visitor: Visitor) {
    let index = this.dataStore.visitors.findIndex(x => x.userId === visitor.userId)
      if(index>=0){
        this.dataStore.visitors.splice(index,1);
      }
    this.visitsObserver.next(this.dataStore.visitors)
  }

  private onCreated(visitor: Visitor) {
    this.dataStore.visitors.push(visitor);
    this.visitsObserver.next(this.dataStore.visitors)
  }
  public onWinner(winner){
    this.newWinnerSubject.next(winner);
  }

  find() {
    var today = new Date();
    today.setHours(0,0,0,0);
    var tomorrow = new Date();
    tomorrow.setHours(24,0,0,0);

    var queryParam = {
      dateTime: {"$gt":today,"$lt":tomorrow}
    };
      this.apiService.get('visits?dateTime[$gt]='+today+'&dateTime[$lt]='+tomorrow).then((response:any) => {
        this.dataStore.visitors = response.data;
        this.visitsObserver.next(this.dataStore.visitors)
    }).catch((err) => {
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/visitors/visitors.service.ts